import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Apis from '../../Apis';
import { showAlert } from '../../ui/dialog';

const Spinner = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" style={{ animation: 'ge-spin 0.8s linear infinite' }}>
        <circle cx="9" cy="9" r="7" fill="none" stroke="#9ca3af" strokeWidth="2" strokeDasharray="22 22" strokeLinecap="round" />
        <style>{`@keyframes ge-spin{to{transform:rotate(360deg);}}`}</style>
    </svg>
);

const DARK = '#1e3a4c';
const DARK_HOVER = '#162e3c';

export default function TrocaSenhaProducao() {
    const { token } = useParams();
    const [senha, setSenha] = useState('');
    const [confirmacao, setConfirmacao] = useState('');
    const [mostrarSenha, setMostrarSenha] = useState(false);
    const [mostrarConfirmacao, setMostrarConfirmacao] = useState(false);
    const [loading, setLoading] = useState(false);

    const alertError = (text) => showAlert({
        title: 'Atenção',
        text,
        icon: 'error',
        dangerMode: true,
    });

    const handleSubmit = async () => {
        if (!token) {
            alertError('O link de troca de senha é inválido ou está incompleto.');
            return;
        }
        if (!senha || !confirmacao) {
            alertError('Preencha os dois campos de senha.');
            return;
        }
        if (senha !== confirmacao) {
            alertError('Os campos senha e confirmação devem ser iguais.');
            return;
        }

        setLoading(true);
        try {
            const response = await fetch(Apis.urlTrocarSenhaUsuario, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ senha, token }),
            });
            const result = await response.json();
            const retorno = result.retorno || result;

            if (!response.ok || retorno.sucesso === false) {
                throw new Error(retorno.mensagem || 'Não foi possível trocar a senha.');
            }

            showAlert({
                title: 'Senha alterada',
                text: retorno.mensagem || 'Sua senha foi alterada com sucesso.',
                icon: 'success',
            });
            setSenha('');
            setConfirmacao('');
        } catch (error) {
            alertError(error.message || 'Erro ao conectar. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ minHeight: '100vh', display: 'flex', maxWidth: 1920, margin: '0 auto' }}>
            <div style={{
                flex: 1, background: DARK, flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                padding: '48px 56px', position: 'relative', overflow: 'hidden',
                display: window.innerWidth < 900 ? 'none' : 'flex',
            }}>
                <div style={{ position: 'absolute', inset: 0, opacity: 0.04, backgroundImage: 'linear-gradient(#fff 1px,transparent 1px),linear-gradient(90deg,#fff 1px,transparent 1px)', backgroundSize: '40px 40px' }} />
                <div style={{ position: 'relative', textAlign: 'center' }}>
                    <h2 style={{ color: '#fff', fontSize: 32, fontWeight: 700, lineHeight: 1.25, margin: '0 0 16px', letterSpacing: '-0.5px' }}>
                        Acesse o GE<br /><span style={{ color: '#94b8cc' }}>Produção.</span>
                    </h2>
                    <p style={{ color: '#6b8fa3', fontSize: 14, lineHeight: 1.75, margin: '0 0 40px' }}>
                        Crie uma nova senha para continuar usando o aplicativo.
                    </p>
                    {['Acesso seguro', 'Senha protegida', 'Aplicativo GE Produção'].map(item => (
                        <div key={item} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginBottom: 14 }}>
                            <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#3d6a85', flexShrink: 0 }} />
                            <span style={{ color: '#8ab0c4', fontSize: 13.5 }}>{item}</span>
                        </div>
                    ))}
                </div>
                <p style={{ position: 'absolute', bottom: 32, color: '#3d6a85', fontSize: 12, margin: 0 }}>© {new Date().getFullYear()} GE Sistemas</p>
            </div>

            <div style={{ flex: 1, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '48px 40px', boxSizing: 'border-box', borderLeft: '1px solid #e5e7eb' }}>
                <div style={{ width: '100%', maxWidth: 400 }}>
                    <div style={{ marginBottom: 36 }}>
                        <h1 style={{ margin: '0 0 6px', fontSize: 22, fontWeight: 700, color: '#111827', letterSpacing: '-0.3px' }}>Alterar senha</h1>
                        <p style={{ margin: 0, fontSize: 13.5, color: '#6b7280' }}>Defina uma nova senha para o GE Produção</p>
                    </div>

                    <div style={{ marginBottom: 14 }}>
                        <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>Nova senha</label>
                        <div style={{ position: 'relative' }}>
                            <input type={mostrarSenha ? 'text' : 'password'} placeholder="Sua nova senha" value={senha} onChange={event => setSenha(event.target.value)} style={{ width: '100%', height: 42, padding: '0 70px 0 12px', border: '1px solid #d1d5db', borderRadius: 4, fontSize: 14, boxSizing: 'border-box' }} />
                            <button type="button" onClick={() => setMostrarSenha(value => !value)} style={{ position: 'absolute', right: 10, top: 12, border: 0, background: 'none', color: '#6b7280', cursor: 'pointer', fontSize: 11 }}>{mostrarSenha ? 'Ocultar' : 'Mostrar'}</button>
                        </div>
                    </div>

                    <div style={{ marginBottom: 24 }}>
                        <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>Confirmar nova senha</label>
                        <div style={{ position: 'relative' }}>
                            <input type={mostrarConfirmacao ? 'text' : 'password'} placeholder="Confirme sua nova senha" value={confirmacao} onChange={event => setConfirmacao(event.target.value)} onKeyDown={event => event.key === 'Enter' && handleSubmit()} style={{ width: '100%', height: 42, padding: '0 70px 0 12px', border: '1px solid #d1d5db', borderRadius: 4, fontSize: 14, boxSizing: 'border-box' }} />
                            <button type="button" onClick={() => setMostrarConfirmacao(value => !value)} style={{ position: 'absolute', right: 10, top: 12, border: 0, background: 'none', color: '#6b7280', cursor: 'pointer', fontSize: 11 }}>{mostrarConfirmacao ? 'Ocultar' : 'Mostrar'}</button>
                        </div>
                    </div>

                    <button onClick={handleSubmit} disabled={loading} style={{ width: '100%', height: 42, borderRadius: 4, border: 'none', background: loading ? '#e5e7eb' : DARK, color: loading ? '#9ca3af' : '#fff', fontSize: 14, fontWeight: 600, cursor: loading ? 'default' : 'pointer', fontFamily: 'inherit', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onMouseEnter={event => { if (!loading) event.currentTarget.style.background = DARK_HOVER; }} onMouseLeave={event => { if (!loading) event.currentTarget.style.background = DARK; }}>
                        {loading ? <Spinner /> : 'Salvar nova senha'}
                    </button>
                </div>
            </div>
        </div>
    );
}
